import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  position: relative;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const ModalTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1F2937;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: #6B7280;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  
  &:hover {
    background: #F3F4F6;
  }
`;

const ModalMessage = styled.p`
  margin: 0 0 24px 0;
  color: #6B7280;
  line-height: 1.5;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => props.primary ? `
    background: #0C53BB;
    color: white;
    border: none;
    
    &:hover {
      background: #0A4A9E;
    }
  ` : `
    background: white;
    color: #374151;
    border: 1px solid #D1D5DB;
    
    &:hover {
      background: #F9FAFB;
    }
  `}
`;
const CancelUploadModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  onKeepUploading,
  fileName = '',
  isCancelAll = false
}) => {
  if (!isOpen) return null;

  let cancelMessage;
  if (isCancelAll) {
    cancelMessage = 'Cancelling now will stop the upload of all remaining files. Are you sure to cancel?';
  } else if (fileName) {
    cancelMessage = `Are you sure you want to cancel the upload of "${fileName}"?`;
  } else {
    cancelMessage = 'Are you sure you want to cancel this upload?';
  }

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Cancel Upload?</ModalTitle>
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </ModalHeader>
        
        <ModalMessage>
          {cancelMessage}
        </ModalMessage>
        
        <ButtonContainer>
          <Button onClick={onKeepUploading}>
            Keep Uploading
          </Button>
          <Button primary onClick={onConfirm}>
            Cancel Upload
          </Button>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

CancelUploadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onKeepUploading: PropTypes.func.isRequired,
  fileName: PropTypes.string,
  isCancelAll: PropTypes.bool,
};

export default CancelUploadModal;
